import { useLocation } from "react-router-dom";
import { useScrollToTop } from "@/hooks/useScrollToTop";

export default function ScrollToTop() {
  const location = useLocation();

  useScrollToTop({
    behavior: "auto",
    delay: 0,
    shouldScroll: !location.hash
  });

  return null;
}
